/* eslint-disable */
import React, { useEffect } from "react";
// TableFooter, TextField 
// import InputMask from 'react-input-mask';

import { Box, Button, Grid, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, InputLabel, FormControl, CircularProgress, AppBar, Divider, Typography } from "@mui/material";
import { makeStyles } from '@mui/styles';
// import Helper from '../../utility/helper';
import ApiHelper from '../../../utility/ApiHelper';

import Paper from '@mui/material/Paper';

import { createState, useState } from '@hookstate/core';
import Title from "../../../sharedcomponents/title/title";
// import RouteConstants from "../../../constants/routeConstants";
//  import { createTheme } from '@mui/material/styles';
// import ArrowRightIcon from '@mui/icons-material/ArrowRight';
// const theme = createTheme();
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import Helper from "../../../utility/helper";
import APIURLConstants from "../../../config/config";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialog from "../../../sharedcomponents/confirmationdialog/confirmationDialog";
import { useHistory } from "react-router-dom";
import { VIEW_PERMISSION } from "../../../constants/Constant";
import AddCreditCard from "./addCreditCard";
import { updateModuleState } from '../../../stores/eventStore';
import PhoneNumber from "../../../sharedcomponents/PhoneNumber/phoneNumber";

const appBarStyle = {
    mb: 1,
    boxShadow: 'none',
    pt: 1,
    pb: 1,
    pl: 1,
    borderTop: '1px solid #D7D7D7',
    borderBottom: '1px solid #D7D7D7',
    backgroundColor: '#F8F8F8',
};
const useStyles = makeStyles(() => ({
    borderSizeColor: {
        // border: '1px solid black',
        // color: 'white',
        // fontSize: 17,
        // fontWeight: 700
    }
}));
const purcahseTicketState = createState({
    name: '',
    email: '',
    phone: '1',
    status: 0
});
const Purchase = (props) => {
    // console.log(props);
    const history = useHistory();
    const classes = useStyles();
    // console.log("props?.compData", typeof props?.compData, props?.compData);

    const state = useState(purcahseTicketState);
    // console.log(props.participant);
    // const [allData, setAllData] = React.useState(null);
    const nightCount = useState({
        friCount: 0,
        satCount: 0,
        sunCount: 0,
    });
    const staticNightCount = useState({
        friCount: 0,
        satCount: 0,
        sunCount: 0,
    });

    const usedNightCount = useState({
        friCount: 0,
        satCount: 0,
        sunCount: 0,
    });

    const friInputArr = [{
        ticketFriNightMasterID: 0,
        ticketFriNightBoulID: 0,
        count: 0,
        friNightTotalCount: 0
    }];
    const satInputArr = [{
        ticketSatNightMasterID: 0,
        ticketSatNightBoulID: 0,
        satCount: 0,
        satNightTotalCount: 0
    }];
    const sunInputArr = [{
        ticketSunNightMasterID: 0,
        ticketSunNightBoulID: 0,
        sunCount: 0,
        sunNightTotalCount: 0
    }];

    const [dynamicFriNight, setDynamicFriNight] = React.useState(friInputArr);
    const [dynamicSatNight, setDynamicSatNight] = React.useState(satInputArr);
    const [dynamicSunNight, setDynamicSunNight] = React.useState(sunInputArr);
    const [friNightCountChanges, setFriNightCountChanges] = React.useState(0);
    // const [friNightMinusCount, setFriNightMinusCount] = React.useState(0);
    const [satNightCountChanges, setSatNightCountChanges] = React.useState(0);
    // const [satNightMinusCount, setSatNightMinusCount] = React.useState(0);
    const [sunNightCountChanges, setSunNightCountChanges] = React.useState(0);
    // const [sunNightMinusCount, setSunNightMinusCount] = React.useState(0);
    // const [purchaseNameError, setPurchaseNameError] = React.useState('');
    // const [purchaseEmailError, setPurchaseEmailError] = React.useState('');
    // const [purchasePhoneError, setPurchasePhoneError] = React.useState('');
    const [showCount, setShowCount] = React.useState(false);
    const [totalCount, setTotalCount] = React.useState(0);
    const [ins, setIns] = React.useState([]);
    const [editData, setEditData] = React.useState([]);
    const [showCreditCard, setShowCreditCard] = React.useState(false);
    const [editID, setEditID] = React.useState(0);
    const [disablePurBtn, setDisablePurBtn] = React.useState(false);

    const eventInfo = Helper.getStorage('eventInfo');
    const [userID, setUserID] = React.useState(0);
    const [eventID, setEventID] = React.useState(0);
    const [btnName, setBtnName] = React.useState(false);
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
        deleteID: ''
    });

    const [selectedCard, setSelectedCard] = React.useState(null);
    // const [shopperRefID, setShopperRefID] = React.useState('');
    const [prevCreditCards, setPrevCreditCards] = React.useState([]);
    const [existingCard, setExistingCard] = React.useState(null);
    const [showCardValidationMessage, setShowCardValidationMessage] = React.useState(false);
    const logoURL = process.env.REACT_APP_CREDIT_LOGOS;
    const userInfo = Helper.getStorage('userInfo');

    useEffect(() => {

        const userInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        setUserID(userInfo.userID);
        setEventID(eventInfo.eventID);
    }, [])

    useEffect(() => {
        if (props && props.compData) {
            const compData1 = props.compData
            state.set({
                name: compData1.contactName,
                email: compData1.contactEmail,
                phone: compData1.contactNo,
                status: compData1.status ? compData1.status : 0
            });
        }
        if (Object.keys(props.newSettingData || {}).length !== 0) {
            const parseData = JSON.parse(props?.newSettingData);
            // setShopperRefID(props.shopperRef);
            const tickerSettingParse = parseData[0].TicketSetting !== undefined ? JSON.parse(parseData[0].TicketSetting) : null

            if (history.location.state && history.location.state.ticketState != null) {
                // console.log(tickerSettingParse,parseData);
                nightCount.set({
                    friCount: tickerSettingParse?.ticketFriPurCount ? tickerSettingParse?.ticketFriPurCount : 0,
                    satCount: tickerSettingParse?.ticketSatPurCount ? tickerSettingParse?.ticketSatPurCount : 0,
                    sunCount: tickerSettingParse?.ticketSunPurCount ? tickerSettingParse?.ticketSunPurCount : 0,
                })
            } else {
                // console.log("tickerSettingParse", tickerSettingParse)
                nightCount.set({
                    friCount: tickerSettingParse ? tickerSettingParse?.ticketFriPurCount : 0,
                    satCount: tickerSettingParse ? tickerSettingParse?.ticketSatPurCount : 0,
                    sunCount: tickerSettingParse ? tickerSettingParse?.ticketSunPurCount : 0,
                })
            }
            staticNightCount.set({
                friCount: tickerSettingParse?.ticketFriPurCount ? tickerSettingParse?.ticketFriPurCount : 0,
                satCount: tickerSettingParse?.ticketSatPurCount ? tickerSettingParse?.ticketSatPurCount : 0,
                sunCount: tickerSettingParse?.ticketSunPurCount ? tickerSettingParse?.ticketSunPurCount : 0,
            })
            setIns(parseData[0])
        } else {
            nightCount.set({
                friCount: 0,
                satCount: 0,
                sunCount: 0,
            })
        }
    }, [props])

    useEffect(() => {
        if (props && props.purchaseData.length > 0) {
            let fC = 0;
            let saC = 0;
            let suC = 0;
            let tCnt = 0;
            props.purchaseData?.map((row) => {
                row.ticketAllStarDetails.map((value) => {
                    // console.log("into map",value);
                    if (value.ticketNightID === 1) {
                        fC += value.ticketCount
                    } else if (value.ticketNightID === 2) {
                        saC += value.ticketCount
                    } else if (value.ticketNightID === 3) {
                        suC += value.ticketCount
                    }
                    tCnt += (value.price * value.ticketCount)
                })
            })
            // console.log(nightCount.get());

            setTotalCount(tCnt)
            nightCount.set({
                friCount: Number(staticNightCount.get().friCount) - fC,
                satCount: Number(staticNightCount.get().satCount) - saC,
                sunCount: Number(staticNightCount.get().sunCount) - suC,
            })

            usedNightCount.set({
                friCount: fC,
                satCount: saC,
                sunCount: suC,
            })
        }
        else {
            nightCount.set({
                friCount: Number(staticNightCount.get().friCount),
                satCount: Number(staticNightCount.get().satCount),
                sunCount: Number(staticNightCount.get().sunCount),
            })

            usedNightCount.set({
                friCount: 0,
                satCount: 0,
                sunCount: 0,
            })
        }
    }, [staticNightCount, props?.purchaseData])

    // const onPurchaseNameChange = (e) =>
    // {
    //     state.set({
    //         ...state.get(),
    //         name: e,
    //     });
    //     if (e === '')
    //     {
    //         setPurchaseNameError('Please Enter Name');
    //         return { flag: 'false' };
    //     } else
    //     {
    //         setPurchaseNameError('');
    //     }
    // }

    // const onPurchaseEmailChange = (e) =>
    // {
    //     state.set({
    //         ...state.get(),
    //         email: e,
    //     });
    //     if (Helper.validEmail(e))
    //     {
    //         setPurchaseEmailError('');
    //         return { flag: 'true' };
    //     } else if (e === '')
    //     {
    //         setPurchaseEmailError('Please Enter Email');
    //         return { flag: 'false' };
    //     } else
    //     {
    //         setPurchaseEmailError('Please enter valid Email');
    //         return { flag: 'false' };
    //     }
    // }

    // const onPurchasePhoneChange = (e) =>
    // {
    //     if (e === '' || e === '1')
    //     {
    //         setPurchasePhoneError('Please Enter Phone');
    //         return { flag: 'false' };
    //     }
    //     //  else if (!e.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/)) {
    //     //     setPurchasePhoneError('Please Enter valid Phone');
    //     //     return { flag: 'false' };
    //     // } 
    //     else
    //     {
    //         setPurchasePhoneError('');
    //     }
    // }

    const AddFriNight = () => {
        setDynamicFriNight(s => {
            return [
                ...s,
                {
                    ticketFriNightMasterID: 0,
                    ticketFriNightBoulID: 0,
                    count: 0,
                    friNightTotalCount: 0
                },

            ];
        });
    }

    const AddSatNight = () => {
        setDynamicSatNight(s => {
            return [
                ...s,
                {
                    ticketFriNightMasterID: 0,
                    ticketSatNightBoulID: 0,
                    satCount: 0,
                    satNightTotalCount: 0
                },

            ];
        });
    }
    const AddSunNight = () => {
        setDynamicSunNight(s => {
            return [
                ...s,
                {
                    ticketFriNightMasterID: 0,
                    ticketSunNightBoulID: 0,
                    sunCount: 0,
                    sunNightTotalCount: 0
                },

            ];
        });
    }
    const handleDisableBtn = () => {
        let prevData
        editData.map((row) => {
            let friData = [];
            let satData = [];
            let sunData = [];

            row.map((value) => {
                if (value.ticketNightID === 1) {
                    friData.push({
                        ticketFriNightMasterID: value.ticketAllStarID,
                        ticketFriNightBoulID: value.ticketPriceID,
                        count: value.ticketCount,
                        ticketAllStarID: value.ticketAllStarID,
                        friNightTotalCount: parseInt(value.price)
                    })
                } else if (value.ticketNightID === 2) {
                    satData.push({
                        ticketSatNightMasterID: value.ticketAllStarID,
                        ticketSatNightBoulID: value.ticketPriceID,
                        satCount: value.ticketCount,
                        ticketAllStarID: value.ticketAllStarID,
                        satNightTotalCount: parseInt(value.price)
                    })

                } else if (value.ticketNightID === 3) {
                    sunData.push({
                        ticketSunNightMasterID: value.ticketAllStarID,
                        ticketSunNightBoulID: value.ticketPriceID,
                        sunCount: value.ticketCount,
                        ticketAllStarID: value.ticketAllStarID,
                        sunNightTotalCount: parseInt(value.price)
                    })

                }
            })
            if (friData.length === 0) {
                friData.push({
                    ticketFriNightMasterID: 0,
                    ticketFriNightBoulID: 0,
                    count: 0,
                    friNightTotalCount: 0
                });
            }
            if (satData.length === 0) {
                satData.push({
                    ticketSatNightMasterID: 0,
                    ticketSatNightBoulID: 0,
                    satCount: 0,
                    satNightTotalCount: 0
                });
            }
            if (sunData.length === 0) {
                sunData.push({
                    ticketSunNightMasterID: 0,
                    ticketSunNightBoulID: 0,
                    sunCount: 0,
                    sunNightTotalCount: 0
                });
            }
            prevData = {
                friDatas: friData,
                satDatas: satData,
                sunDatas: sunData,
            };
        })
        let currentData = {
            friDatas: dynamicFriNight,
            satDatas: dynamicSatNight,
            sunDatas: dynamicSunNight,
        };
        setTimeout(() => {
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisablePurBtn(true);
                props.setIsPurchaseDirty(true);
            } else {
                setDisablePurBtn(false);
                props.setIsPurchaseDirty(true);
            }
        }, 500);
    }

    const friNightBowlChange = (e) => {
        const index = e.target.name;
        setDynamicFriNight(s => {
            const dynamicFriNight = s.slice();
            dynamicFriNight[index].ticketFriNightBoulID = Number(e.target.value);
            return dynamicFriNight;
        });
        props.priceValue.map((v) => {
            if (v.ticketPriceID === e.target.value) {
                setDynamicFriNight(s => {
                    const dynamicFriNight = s.slice();
                    dynamicFriNight[index].friNightTotalCount = Number(v.price);
                    return dynamicFriNight;
                });
            }
        })
    }

    const friNightCountChange = (e) => {
        const index = e.target.name;

        setDynamicFriNight(s => {
            const dynamicFriNight = s.slice();
            dynamicFriNight[index].count = Number(Math.max(0, parseInt(e.target.value)).toString().slice(0, 3));
            return dynamicFriNight;
        });
        setFriNightCountChanges(Number(friNightCountChanges) + Number(Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)))
    }

    const satNightBowlChange = (e) => {
        const index = e.target.name;
        setDynamicSatNight(s => {
            const dynamicSatNight = s.slice();
            dynamicSatNight[index].ticketSatNightBoulID = Number(e.target.value);
            return dynamicSatNight;
        });

        props.priceValue.map((v) => {
            if (v.ticketPriceID === e.target.value) {
                setDynamicSatNight(s => {
                    const dynamicSatNight = s.slice();
                    dynamicSatNight[index].satNightTotalCount = Number(v.price);
                    return dynamicSatNight;
                });
            }
        })
    }
    const satNightCountChange = (e) => {
        const index = e.target.name;
        setDynamicSatNight(s => {
            const dynamicSatNight = s.slice();
            dynamicSatNight[index].satCount = Number(Math.max(0, parseInt(e.target.value)).toString().slice(0, 3));
            return dynamicSatNight;
        });
        setSatNightCountChanges(Number(satNightCountChanges) + Number(Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)))
    }

    const sunNightBowlChange = (e) => {
        const index = e.target.name;
        setDynamicSunNight(s => {
            const dynamicSunNight = s.slice();
            dynamicSunNight[index].ticketSunNightBoulID = Number(e.target.value);
            return dynamicSunNight;
        });
        props.priceValue.map((v) => {
            if (v.ticketPriceID === e.target.value) {
                setDynamicSunNight(s => {
                    const dynamicSunNight = s.slice();
                    dynamicSunNight[index].sunNightTotalCount = Number(v.price);
                    return dynamicSunNight;
                });
            }
        })
    }
    const preventMinus = (e) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };
    const sunNightCountChange = (e) => {
        const index = e.target.name;
        setDynamicSunNight(s => {
            const dynamicSunNight = s.slice();
            dynamicSunNight[index].sunCount = Number(Math.max(0, parseInt(e.target.value)).toString().slice(0, 3));
            return dynamicSunNight;
        });
        setSunNightCountChanges(Number(sunNightCountChanges) + Number(Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)))
    }

    const resetPurchaseState = () => {
        setDynamicFriNight(friInputArr)
        setDynamicSatNight(satInputArr)
        setDynamicSunNight(sunInputArr)
        state.set({
            name: '',
            email: '',
            phone: '1',
            status: 0
        })
    }

    const validateFriTicketCount = () => {

        let validFri = 0;
        dynamicFriNight.map((f) => {
            validFri += f.count;
        })
        if (editID !== '') {
            let fCs = 0;
            props.purchaseData?.map((row) => {
                row.ticketAllStarDetails.map((value) => {
                    if (editID !== value.ticketAllStarID) {
                        if (value.ticketNightID === 1) {
                            fCs += value.ticketCount
                        }
                    }
                })
            })
            validFri = validFri + fCs;
        }

        if (nightCount.get().friCount !== staticNightCount.get().friCount) {
            if (editID !== "") {
                if (validFri > staticNightCount.get().friCount) {
                    return { vflag: 'false' };
                }
            } else {
                if (validFri > nightCount.get().friCount) {
                    return { vflag: 'false' };
                }
            }

        } else {
            if (validFri > staticNightCount.get().friCount) {
                return { vflag: 'false' };
            }
        }

    }
    const validateSatTicketCount = () => {
        let validSat = 0;
        dynamicSatNight.map((f) => {
            validSat += f.satCount;
        })
        if (editID !== '') {
            let fCs = 0;
            props.purchaseData?.map((row) => {
                row.ticketAllStarDetails.map((value) => {
                    if (editID !== value.ticketAllStarID) {
                        if (value.ticketNightID === 2) {
                            fCs += value.ticketCount
                        }
                    }
                })
            })
            validSat = validSat + fCs;
        }
        if (nightCount.get().satCount !== staticNightCount.get().satCount) {
            if (editID !== "") {
                if (validSat > staticNightCount.get().satCount) {
                    return { vflag: 'false' };
                }
            } else {
                if (validSat > nightCount.get().satCount) {
                    return { vflag: 'false' };
                }
            }
        } else {
            if (validSat > staticNightCount.get().satCount) {
                return { vflag: 'false' };
            }
        }
    }
    const validateSunTicketCount = () => {
        let validSun = 0;
        dynamicSunNight.map((f) => {
            validSun += f.sunCount;
        })
        if (editID !== '') {
            let fCs = 0;
            props.purchaseData?.map((row) => {
                row.ticketAllStarDetails.map((value) => {
                    if (editID !== value.ticketAllStarID) {
                        if (value.ticketNightID === 3) {
                            fCs += value.ticketCount
                        }
                    }
                })
            })
            validSun = validSun + fCs;
        }
        if (nightCount.get().sunCount !== staticNightCount.get().sunCount) {
            if (editID !== "") {
                if (validSun > staticNightCount.get().sunCount) {
                    return { vflag: 'false' };
                }
            } else {
                if (validSun > nightCount.get().sunCount) {
                    return { vflag: 'false' };
                }
            }
        } else {
            if (validSun > staticNightCount.get().sunCount) {
                return { vflag: 'false' };
            }
        }
    }

    const validatePurchaseTickets = () => {
        if (editID === '') {
            if (nightCount.get().friCount <= 0 && nightCount.get().satCount <= 0 && nightCount.get().sunCount <= 0) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Cannot add more than the allotted tickets request',
                });
                return;
            }
        }
        const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
        const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
        //  console.log("Object.keys(props?.compData).length",props, Object.keys(props?.compData));
        if (Object.keys(props?.compData).length === 0) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please add Complimentary Ticket First',
            });
            return;
        }
        
        // if (((props.agentInfo) &&
        //     (Helper.isAdminUser(props.agentInfo) ||
        //         (props.agentInfo.roles && Helper.isEventAdmin(props.agentInfo)) || (props.agentInfo.roles && Helper.isEventStaff(props.agentInfo)))) && !props.agentInfo
        // ) {
        //     console.log("asdasd"); 
        //     if (props.participant === null) {
        //         props.setSnackBarProps({
        //             ...props.snackBarProps,
        //             openSnack: true,
        //             variant: 'error',
        //             message: 'Please select participant first',
        //         });
        //         return;
        //     }
        // } else 
        if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            if (props.participant === null) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please select participant first',
                });
                return;
            }
        }
        const vFTicC = validateFriTicketCount();
        const vSTicC = validateSatTicketCount();
        const vSuTicC = validateSunTicketCount();
        if (vFTicC?.vflag === 'false') {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'You cannot exceed count more than ' + nightCount.get().friCount + ' friday night',
            });
            return
        } else if (vSTicC?.vflag === 'false') {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'You cannot exceed count more than ' + nightCount.get().satCount + ' saturday night',
            });
            return
        } else if (vSuTicC?.vflag === 'false') {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'You cannot exceed count more than ' + nightCount.get().sunCount + ' sunday night',
            });
            return
        }
        // const vName = onPurchaseNameChange(state.name.get());
        // const vEmail = onPurchaseEmailChange(state.email.get());
        // const vphone = onPurchasePhoneChange(state.phone.get());

        // if (vName?.flag === 'false' || vEmail?.flag === 'false' || vphone?.flag === 'false')
        // {
        //     return;
        // }

        // const tDate = ValidateDate();
        let mergedArray = [...dynamicFriNight, ...dynamicSatNight, ...dynamicSunNight]
        // console.log('mergedArray', mergedArray);

        let newPushData = [];
        mergedArray.map((value) => {
            // console.log("value", value);
            if (value.ticketFriNightBoulID) {
                newPushData.push({
                    ticketAllStarDetailID: 0,
                    ticketAllStarID: value.ticketAllStarID ? value.ticketAllStarID : 0,
                    ticketMainTypeID: 2, // for complementry
                    ticketNightID: 1,// friday
                    ticketSubTypeID: 1,
                    ticketCount: isNaN(value.count) ? 0 : value.count,
                    ticketPriceID: value.ticketFriNightBoulID,
                })
            } else if (value.ticketSatNightBoulID) {
                newPushData.push({
                    ticketAllStarDetailID: 0,
                    ticketAllStarID: value.ticketAllStarID ? value.ticketAllStarID : 0,
                    ticketMainTypeID: 2, // for complementry
                    ticketNightID: 2,// saturday
                    ticketSubTypeID: 1,
                    ticketCount: isNaN(value.satCount) ? 0 : value.satCount,
                    ticketPriceID: value.ticketSatNightBoulID,
                })
            } else if (value.ticketSunNightBoulID) {
                newPushData.push({
                    ticketAllStarDetailID: 0,
                    ticketAllStarID: value.ticketAllStarID ? value.ticketAllStarID : 0,
                    ticketMainTypeID: 2, // for complementry
                    ticketNightID: 3,// sunday
                    ticketSubTypeID: 1,
                    ticketCount: isNaN(value.sunCount) ? 0 : value.sunCount,
                    ticketPriceID: value.ticketSunNightBoulID,
                })
            }
        });
        if (newPushData.length === 0) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select ticket value and count',
            });
            return
        }
        return newPushData;
    }
    const SETEmailNotification = (postCompData, auditMailDataObj) => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');

        let postObj = {};
        let emailNotificationObj = {};
        emailNotificationObj.userID = postCompData.userID;
        emailNotificationObj.eventID = eventInfo.eventID;
        emailNotificationObj.templateType = 'ALLStarTickets';
        emailNotificationObj.ID = postCompData.ticketAllStarID;
        emailNotificationObj.ModifyBy = userInfo.userID;
        emailNotificationObj.TranportType = 'ALLStarTickets';
        emailNotificationObj.ModuleID = 17;
        postObj.emailNotificationObject = emailNotificationObj;
        postObj.emailAuditData = auditMailDataObj;
        // props.calulateOldNewTicketData(postObj)
        // return ApiHelper.post(
        //     APIURLConstants.POST_TICKET_ALL_STAR_NOTIFICATION_EMAIL,
        //     postObj
        // )
        //     .then((result) => {
        //         return result.data;
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });
    };
    const addPurchase = () => {
        // purchase ticket validation call
        let newPushData = validatePurchaseTickets();
 
        if (selectedCard == null && editID == 0) {
            setShowCardValidationMessage(true);
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please enter credit card information first',
            });
            return;
        }
        else if (state.get().name === '' || state.get().email === '' || state.get().phone === '') {
            setShowCardValidationMessage(true);            
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please Enter a contact details',
            });
            return;
        }else if(newPushData && newPushData.length > 0){
            let count = 0
            newPushData.map((val) => {    
                count = count + val.ticketCount    
            })
            if(count <= 0){
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please Enter Ticket Count',
                });
                return; 
            }
        }
        const eventInfo = Helper.getStorage('eventInfo');
        // console.log("newPushData", newPushData);
        setShowCardValidationMessage(false);
        let postPurchaseData = {
            ticketAllStarID: editID !== '' ? editID : 0,
            eventID: eventInfo.eventID,
            userID: props.participant ? props.participant.userID : props.agentInfo ? props.agentInfo.userID : userInfo.userID,
            contactName: state.get().name,
            contactEmail: state.get().email,
            contactNo: state.get().phone,
            status: props.isAdminUser && state.status.get() === 0 ? 1 : state.get().status,
            createdBy: userInfo.userID,
            // connectionID: props.agentInfo ? props.agentInfo.userID : (props.participant ? props.participant.userID : userInfo.userID),
            connectionID: (Helper.isEventAdmin(userInfo) || Helper.isAdminUser(userInfo)) ? props.participant ? props.participant.userID : userInfo.userID : userInfo.userID,
            ticketAllStarDetails: newPushData
        };

        if (selectedCard) {
            postPurchaseData['creditCardID'] = selectedCard.creditCardID ? selectedCard.creditCardID : 0;
            postPurchaseData['summary'] = selectedCard.summary;
            postPurchaseData['token'] = selectedCard.token;
            postPurchaseData['reference'] = selectedCard.reference;
            postPurchaseData['brand'] = selectedCard.brand;
            postPurchaseData['store'] = selectedCard.store;
            postPurchaseData['cardName'] = selectedCard.cardName;
            postPurchaseData['email'] = selectedCard.email;

        }
        setDisablePurBtn(true)
        // debugger
        ApiHelper.post(APIURLConstants.POST_ALLSTAR_EVENT_TICKETS, postPurchaseData)
            .then(async (res) => {
                if (res.data) {
                    props.setIsPurchaseDirty(true);
                    // console.log("props", res.data);
                    setShowCount(true);
                    props.onPurchaseSave()
                    setDisablePurBtn(false)
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Purchase ticket created successfully',
                    });
                    // if (postPurchaseData.status > 0) {
                    //     let auditMailDataObj = calculateOldNewTicketData(postPurchaseData);
                    //     if (auditMailDataObj && auditMailDataObj.length > 0) {
                    //         SETEmailNotification(postPurchaseData, auditMailDataObj);
                    //     }
                    // }

                    props.getPurchaseData(props.participant?.userID ? props.participant?.userID : userInfo.userID)
                    setSelectedCard(null);
                    setExistingCard(null);
                    resetPurchaseState()
                    setBtnName(false);
                    setEditID(0);
                    await updateModuleState();
                }
            })
            .catch((err) => {
                setDisablePurBtn(false)
                if(err.response.data == "Please enter ticket count"){
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: err.response.data,
                    });
                }  
                console.log(err);
            });
    }

    const calculateOldNewTicketData = (postPurchaseData) => {
        let postObj = [];
        let oldData = null;
        let newData = null;
        let friOldNightCount = 0;
        let satOldNightCount = 0;
        let sunOldNightCount = 0;
        let friNewNightCount = 0;
        let satNewNightCount = 0;
        let sunNewNightCount = 0;

        if (props.purchaseData && props.purchaseData.length > 0 && props.purchaseData.some(i => i.ticketAllStarDetails && i.ticketAllStarDetails.length > 0)) {
            props.purchaseData.forEach(data => {
                if (data.ticketAllStarDetails) {
                    data.ticketAllStarDetails.forEach(i => {
                        if (i.ticketNightID === 1) {
                            friOldNightCount += i.ticketCount;
                        } else if (i.ticketNightID === 2) {
                            satOldNightCount += i.ticketCount;
                        }
                        else if (i.ticketNightID === 3) {
                            sunOldNightCount += i.ticketCount;
                        }
                    })
                }
            });

            if (postPurchaseData.ticketAllStarID && postPurchaseData.ticketAllStarID > 0) {
                friNewNightCount = calculateNewNightCount(postPurchaseData, 1, friOldNightCount);
                satNewNightCount = calculateNewNightCount(postPurchaseData, 2, satOldNightCount);
                sunNewNightCount = calculateNewNightCount(postPurchaseData, 3, sunOldNightCount);
            }
            else {
                let ticketValues = calculateTicketCount(postPurchaseData);
                friNewNightCount = friOldNightCount + ticketValues[0];
                satNewNightCount = satOldNightCount + ticketValues[1];
                sunNewNightCount = sunOldNightCount + ticketValues[2];
            }

            oldData = {
                friCount: friOldNightCount,
                satCount: satOldNightCount,
                sunCount: sunOldNightCount,
                TicketMainTypeID: 2
            }
            newData = {
                friCount: friNewNightCount,
                satCount: satNewNightCount,
                sunCount: sunNewNightCount,
                TicketMainTypeID: 2
            }
        }
        else {
            let ticketValues = calculateTicketCount(postPurchaseData);
            friNewNightCount = friOldNightCount + ticketValues[0];
            satNewNightCount = satOldNightCount + ticketValues[1];
            sunNewNightCount = sunOldNightCount + ticketValues[2];

            newData = {
                friCount: friNewNightCount,
                satCount: satNewNightCount,
                sunCount: sunNewNightCount,
                TicketMainTypeID: 2
            }
        }
        if (JSON.stringify(oldData) !== JSON.stringify(newData)) {
            postObj.push(newData);
            if (oldData) {
                postObj.push(oldData);
            }
            postObj.forEach(i => {
                i.contactName = state.get().name;
                i.contactEmail = state.get().email;
                i.contactNo = state.get().phone ? Helper.formatPhoneNumber(state.get().phone) : '';
            })
        }

        //console.log('postObj', postObj);
        return postObj;

    }

    const calculateNewNightCount = (postPurchaseData, nightID, oldCount) => {
        let newCount = 0;
        let existingPurchaseData = props.purchaseData.find(i => i.ticketAllStarID === postPurchaseData.ticketAllStarID);
        if (existingPurchaseData) {
            let existingData = existingPurchaseData.ticketAllStarDetails.find(i => i.ticketNightID === nightID);
            let newData = postPurchaseData.ticketAllStarDetails.find(i => i.ticketNightID === nightID);
            let diff = 0;
            diff = (existingData && newData) ? (existingData.ticketCount - newData.ticketCount) : (existingData == undefined && newData) ? newData.ticketCount : 0;
            newCount = oldCount - diff;
        }
        return Math.abs(newCount);
    }

    const calculateTicketCount = (postPurchaseData) => {
        let friNightCount = 0;
        let satNightCount = 0;
        let sunNightCount = 0;

        if (postPurchaseData) {
            postPurchaseData.ticketAllStarDetails.forEach(i => {
                if (i.ticketNightID === 1) {
                    friNightCount += i.ticketCount;
                } else if (i.ticketNightID === 2) {
                    satNightCount += i.ticketCount;
                }
                else if (i.ticketNightID === 3) {
                    sunNightCount += i.ticketCount;
                }
            });
        }

        return [friNightCount, satNightCount, sunNightCount];
    }

    const editPurchase = (data) => {
        setDisablePurBtn(true);
        setBtnName(true);
        setEditData([])
        // setPurchaseNameError('')
        // setPurchaseEmailError('')
        // setPurchasePhoneError('')

        // state.set({
        //     name: data.contactName,
        //     email: data.contactEmail,
        //     phone: data.contactNo
        // })
        setEditID(data.ticketAllStarID);
        setExistingCard({
            summary: data.summary,
            //token: data.token,
            //reference: data.reference,
            brand: data.brand,
            //store: data.store,
            cardName: data.cardName
        });
        setSelectedCard({
            summary: data.summary,
            //token: data.token,
            //reference: data.reference,
            brand: data.brand,
            //store: data.store,
            cardName: data.cardName
        });
        let newData = [];
        Object.keys(data).map((key) => {
            if (key === 'ticketAllStarDetails') {
                newData.push(data[key])
            }
        })

        setEditData(newData)


        newData.map((row) => {
            let friData = [];
            let satData = [];
            let sunData = [];
            let fC = 0;
            let saC = 0;
            let suC = 0;
            row.map((value) => {
                if (value.ticketNightID === 1) {
                    friData.push({
                        ticketFriNightMasterID: value.ticketAllStarID,
                        ticketFriNightBoulID: value.ticketPriceID,
                        count: value.ticketCount,
                        ticketAllStarID: value.ticketAllStarID,
                        friNightTotalCount: value.price
                    })

                    fC += value.ticketCount;
                } else if (value.ticketNightID === 2) {
                    satData.push({
                        ticketSatNightMasterID: value.ticketAllStarID,
                        ticketSatNightBoulID: value.ticketPriceID,
                        satCount: value.ticketCount,
                        ticketAllStarID: value.ticketAllStarID,
                        satNightTotalCount: value.price
                    })
                    saC += value.ticketCount;
                } else if (value.ticketNightID === 3) {
                    sunData.push({
                        ticketSunNightMasterID: value.ticketAllStarID,
                        ticketSunNightBoulID: value.ticketPriceID,
                        sunCount: value.ticketCount,
                        ticketAllStarID: value.ticketAllStarID,
                        sunNightTotalCount: value.price
                    })
                    suC += value.ticketCount;
                }
            })
            if (friData.length === 0) {
                friData.push({
                    ticketFriNightMasterID: 0,
                    ticketFriNightBoulID: 0,
                    count: 0,
                    friNightTotalCount: 0
                });
            }
            if (satData.length === 0) {
                satData.push({
                    ticketSatNightMasterID: 0,
                    ticketSatNightBoulID: 0,
                    satCount: 0,
                    satNightTotalCount: 0
                });
            }
            if (sunData.length === 0) {
                sunData.push({
                    ticketSunNightMasterID: 0,
                    ticketSunNightBoulID: 0,
                    sunCount: 0,
                    sunNightTotalCount: 0
                });
            }
            setDynamicFriNight(friData)
            setDynamicSatNight(satData)
            setDynamicSunNight(sunData)
            nightCount.set({
                friCount: staticNightCount.get().friCount - fC,
                satCount: staticNightCount.get().satCount - saC,
                sunCount: staticNightCount.get().sunCount - suC,
            })
        })
        let fCs = 0;
        let saCs = 0;
        let suCs = 0;
        props.purchaseData.map((row) => {
            if (row.ticketAllStarID !== data.ticketAllStarID) {
                row.ticketAllStarDetails.map((value) => {
                    if (value.ticketNightID === 1) {
                        fCs += value.ticketCount
                    } else if (value.ticketNightID === 2) {
                        saCs += value.ticketCount
                    } else if (value.ticketNightID === 3) {
                        suCs += value.ticketCount
                    }
                })
            }
        })
        nightCount.set({
            friCount: nightCount.get().friCount - fCs,
            satCount: nightCount.get().satCount - saCs,
            sunCount: nightCount.get().sunCount - suCs,
        })

    }
    const deleteAllStarDetail = (data) => {

        deleteConfirmation.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: "Are you want to delete this Ticket?",
            deleteID: data.ticketAllStarID
        });
    }
    const handleConfirmation = () => {
        const userInfo = Helper.getStorage('userInfo');
        ApiHelper.post(APIURLConstants.DELETE_ALLSTAR_TICKETS_DETAIL, {
            ids: String(deleteConfirmation.get().deleteID),
            modifiedBy: userInfo.userID,
            isAdditionalTicket: false,
            eventID: eventInfo.eventID
        })
            .then((res) => {
                if (res.data) {
                    props.onPurchaseSave()
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Ticket detail deleted successfully',
                    });
                    props.getPurchaseData(props.participant?.userID ? props.participant?.userID : userInfo.userID);
                    updateModuleState()
                    deleteConfirmation.set({
                        ...deleteConfirmation.get(),
                        open: false,
                    });
                }
            })
            .catch((error) => {
                console.log(error);
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting ticket Details';
                }
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
    };

    const addCreditCard = () => {
        // purchase ticket validation call
        let newPushData = validatePurchaseTickets() || [];
        if (newPushData.length > 0) {
            if (userID) {
                const passUserID = props.participant ? props.participant.userID : userID;
                const connectionID = props.agentInfo ? props.agentInfo.userID : passUserID;

                ApiHelper.get(APIURLConstants.GET_PREV_DETAILS(connectionID, passUserID))
                    .then(res => {
                        if (res.data) {
                            setPrevCreditCards(res.data);
                            setShowCreditCard(true);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
            else {
                setShowCreditCard(true);
            }
        }
    }
    const storeCardInfo = (obj) => {
        // console.log("cardSummary: ", cardSummary);
        // console.log("cardToken : ", cardToken);
        setSelectedCard(obj)
        setDisablePurBtn(false);
    }

    return (
        <>
            <Box >
                <AppBar position="static" color="default" sx={appBarStyle}>
                    <Typography
                        variant="h4"
                        flexGrow={1}
                        fontSize={15}
                        fontWeight={700}
                        fontFamily={'Lato'}
                        noWrap
                        fontStyle="normal"
                        color='primary'
                        component="div"
                        sx={{
                            ml: 1,
                        }}
                    >Purchase Tickets</Typography>
                    {/* <Title
                        title={'Purchase Tickets'}
                        // addicon="land"
                        sx={{
                            ml: 1,
                        }}
                    /> */}
                </AppBar>
                <TableContainer component={Paper}>
                    {ins.PInstruction ? <Box sx={{ mb: 2, ml: 2 }} >{ins.PInstruction}</Box> : null}
                    <Divider />
                    <Table sx={{ minWidth: 350 }} aria-label="simple table">
                        <TableHead >
                            <TableRow>
                                <TableCell className={classes.borderSizeColor} width="20%" >Tickets For Purchase</TableCell>
                                <TableCell className={classes.borderSizeColor} width="80%" >
                                    <Grid
                                        container
                                        alignItems="center"
                                        justify="center"
                                    >
                                        <Grid item align="center" xs={3}>
                                            <Box sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '100%',
                                                },
                                            }}>
                                                Fri (Used/Alloted): {usedNightCount.get().friCount}/{staticNightCount.get().friCount}
                                            </Box>
                                        </Grid>
                                        <Grid item align="center" xs={3} >
                                            <Box sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '100%',
                                                },
                                            }}>
                                                Sat (Used/Alloted): {usedNightCount.get().satCount}/{staticNightCount.get().satCount}
                                            </Box>
                                        </Grid>
                                        <Grid item align="center" xs={3} >
                                            <Box sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '100%',
                                                },
                                            }}>
                                                Sun (Used/Alloted): {usedNightCount.get().sunCount}/{staticNightCount.get().sunCount}
                                            </Box>
                                        </Grid>
                                        <Grid align="center" xs={3}>
                                            <Box sx={{
                                                width: {
                                                    xs: '100%',
                                                    md: '100%',
                                                },
                                            }}>
                                                Total: ${totalCount}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row" align="left">
                                    Friday Night
                                    <Box>
                                        < AddCircleRoundedIcon
                                            sx={{ color: '#008000' }}
                                            onClick={AddFriNight}
                                        />
                                    </Box>
                                </TableCell>
                                <TableCell component="th" scope="row" align="left">
                                    {dynamicFriNight.map((items, i) => {
                                        // console.log(items);
                                        return (
                                            <>
                                                <Grid
                                                    container
                                                    alignItems="center"
                                                    justify="center"
                                                >
                                                    <Grid align="center" xs={2}>
                                                        {/* {i === 0 && nightCount.get().friCount} */}
                                                    </Grid>
                                                    <Grid item align="left" xs={4} sx={{ mt: 1 }}>
                                                        <FormControl fullWidth>
                                                            <InputLabel id="friNightSelectLabel">Select</InputLabel>
                                                            <Select
                                                                sx={{
                                                                    width: {
                                                                        xs: '100%',
                                                                        md: '80%',
                                                                    },
                                                                    // marginLeft: '-20%'
                                                                }}
                                                                label="Select"
                                                                labelId="friNightSelectLabel"
                                                                name={i}
                                                                size="small"
                                                                value={items.ticketFriNightBoulID === 0 ? "" : items.ticketFriNightBoulID}
                                                                // defaultValue={items.ticketFriNightBoulID}
                                                                onChange={(e) => { friNightBowlChange(e); handleDisableBtn() }}
                                                            >
                                                                {props.priceValue !== null ? props.priceValue.map((val, i) => {
                                                                    if (val.ticketNightID === 1) {
                                                                        return (
                                                                            <MenuItem key={i} value={val.ticketPriceID}>{val.typePrice}</MenuItem>
                                                                        )
                                                                    }
                                                                }) : null}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item align="left" xs={4}>
                                                        {/* <FormControl fullWidth>
                                                            <InputLabel id="demo-simple-select-label">Select</InputLabel>
                                                            <Select
                                                                sx={{
                                                                    width: {
                                                                        xs: '100%',
                                                                        md: '80%',
                                                                    },
                                                                }}
                                                                labelId="demo-simple-select-label"
                                                                id="demo-simple-select"
                                                                label="Select"
                                                                name={i}
                                                                size="small"
                                                                value={items.count === 0 ? "" : items.count}
                                                                onChange={(e) => friNightCountChange(e)}
                                                            >
                                                                <MenuItem value={1}>1</MenuItem>
                                                                <MenuItem value={2}>2</MenuItem>
                                                                <MenuItem value={3}>3</MenuItem>
                                                                <MenuItem value={4}>4</MenuItem>
                                                                <MenuItem value={5}>5</MenuItem>
                                                                <MenuItem value={6}>6</MenuItem>
                                                            </Select>
                                                        </FormControl> */}
                                                        <TextField
                                                            type="number"
                                                            size="small"
                                                            fullWidth
                                                            name={i}
                                                            // label="Ring Size"
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            onKeyPress={preventMinus}
                                                            value={items.count === 0 ? "" : items.count}
                                                            inputProps={{
                                                                min: 0,
                                                                max: nightCount.get().friCount,
                                                                step: "1"
                                                            }}
                                                            sx={{
                                                                width: {
                                                                    xs: '100%',
                                                                    md: '80%',
                                                                },
                                                            }}
                                                            onChange={(e) => { friNightCountChange(e); handleDisableBtn() }}
                                                        />
                                                    </Grid>
                                                    <Grid align="center" xs={2}>
                                                        ${!isNaN(Number(items.friNightTotalCount) * Number(items.count)) ? (Number(items.friNightTotalCount) * Number(items.count)) : 0}
                                                    </Grid>
                                                </Grid>
                                            </>
                                        )
                                    })}
                                </TableCell>
                            </TableRow>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row" align="left">
                                    Saturday Night
                                    <Box>
                                        < AddCircleRoundedIcon
                                            sx={{ color: '#008000' }}
                                            onClick={AddSatNight}
                                        />
                                    </Box>
                                </TableCell>
                                <TableCell component="th" scope="row" align="left">
                                    {dynamicSatNight.map((items, i) => {
                                        // console.log(items, typeof items.satCount,typeof items.satCount,items.satCount);
                                        return (
                                            <>
                                                <Grid
                                                    container
                                                    alignItems="center"
                                                    justify="center"
                                                >
                                                    <Grid align="center" xs={2}>
                                                        {/* {i === 0 && nightCount.get().satCount} */}
                                                    </Grid>
                                                    <Grid item align="left" xs={4} sx={{ mt: 1 }}>
                                                        <FormControl fullWidth>
                                                            <InputLabel id="satNightSelectLabel">Select</InputLabel>
                                                            <Select
                                                                labelId="satNightSelectLabel"
                                                                label="Select"
                                                                sx={{
                                                                    width: {
                                                                        xs: '100%',
                                                                        md: '80%',
                                                                    },
                                                                }}
                                                                name={i}
                                                                size="small"
                                                                value={items.ticketSatNightBoulID === 0 ? "" : items.ticketSatNightBoulID}
                                                                // defaultValue={1}
                                                                onChange={(e) => { satNightBowlChange(e); handleDisableBtn() }}
                                                            >
                                                                {props.priceValue.map((val, i) => {
                                                                    if (val.ticketNightID === 2) {
                                                                        return (
                                                                            <MenuItem key={i} value={val.ticketPriceID}>{val.typePrice}</MenuItem>
                                                                        )
                                                                    }
                                                                })}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item align="left" xs={4}>
                                                        {/* <FormControl fullWidth>
                                                            <InputLabel id="demo-simple-select-label">Select</InputLabel>
                                                            <Select
                                                                sx={{
                                                                    width: {
                                                                        xs: '100%',
                                                                        md: '80%',
                                                                    },
                                                                }}
                                                                labelId="demo-simple-select-label"
                                                                id="demo-simple-select"
                                                                label="Select"
                                                                name={i}
                                                                size="small"
                                                                value={items.satCount === 0 ? "" : items.satCount}
                                                                onChange={(e) => satNightCountChange(e)}
                                                            >
                                                                <MenuItem value={1}>1</MenuItem>
                                                                <MenuItem value={2}>2</MenuItem>
                                                                <MenuItem value={3}>3</MenuItem>
                                                                <MenuItem value={4}>4</MenuItem>
                                                                <MenuItem value={5}>5</MenuItem>
                                                                <MenuItem value={6}>6</MenuItem>
                                                            </Select>
                                                        </FormControl> */}
                                                        <TextField
                                                            type="number"
                                                            size="small"
                                                            fullWidth
                                                            name={i}
                                                            id="outlined-basic"
                                                            onKeyPress={preventMinus}
                                                            variant="outlined"
                                                            value={items.satCount === 0 ? "" : items.satCount}
                                                            inputProps={{
                                                                min: 0,
                                                                max: nightCount.get().satCount,
                                                                step: "1"
                                                            }}
                                                            sx={{
                                                                width: {
                                                                    xs: '100%',
                                                                    md: '80%',
                                                                },
                                                            }}
                                                            onChange={(e) => { satNightCountChange(e); handleDisableBtn() }}
                                                        />
                                                    </Grid>
                                                    <Grid align="center" xs={2}>
                                                        ${!isNaN(Number(items.satNightTotalCount) * Number(items.satCount)) ? Number(items.satNightTotalCount) * Number(items.satCount) : 0}
                                                    </Grid>
                                                </Grid>
                                            </>
                                        )
                                    })}
                                </TableCell>
                            </TableRow>
                            <TableRow
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row" align="left">
                                    Sunday Night
                                    <Box>
                                        < AddCircleRoundedIcon
                                            sx={{ color: '#008000' }}
                                            onClick={AddSunNight}

                                        />
                                    </Box>
                                </TableCell>
                                <TableCell component="th" scope="row" align="left">
                                    {dynamicSunNight.map((items, i) => {
                                        return (
                                            <>
                                                <Grid
                                                    container
                                                    alignItems="center"
                                                    justify="center"
                                                >
                                                    <Grid align="center" xs={2}>
                                                        {/* {i === 0 && nightCount.get().sunCount} */}
                                                    </Grid>
                                                    <Grid item align="left" xs={4} sx={{ mt: 1 }}>
                                                        <FormControl fullWidth>
                                                            <InputLabel id="sunNightSelectLabel">Select</InputLabel>
                                                            <Select
                                                                labelId="sunNightSelectLabel"
                                                                label="Select"
                                                                sx={{
                                                                    width: {
                                                                        xs: '100%',
                                                                        md: '80%',
                                                                    },
                                                                }}
                                                                name={i}
                                                                size="small"
                                                                value={items.ticketSunNightBoulID === 0 ? "" : items.ticketSunNightBoulID}
                                                                defaultValue={1}
                                                                onChange={(e) => { sunNightBowlChange(e); handleDisableBtn() }}
                                                            >
                                                                {props.priceValue.map((val, i) => {
                                                                    if (val.ticketNightID === 3) {
                                                                        return (
                                                                            <MenuItem key={i} value={val.ticketPriceID}>{val.typePrice}</MenuItem>
                                                                        )
                                                                    }
                                                                })}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item align="left" xs={4}>
                                                        {/* <FormControl fullWidth>
                                                            <InputLabel id="sunNightCountSelect">Select</InputLabel>
                                                            <Select
                                                                sx={{
                                                                    width: {
                                                                        xs: '100%',
                                                                        md: '80%',
                                                                    },
                                                                }}
                                                                labelId="sunNightCountSelect"
                                                                label="Select"
                                                                name={i}
                                                                size="small"
                                                                value={items.sunCount === 0 ? "" : items.sunCount}
                                                                onChange={(e) => sunNightCountChange(e)}
                                                            >
                                                                <MenuItem value={1}>1</MenuItem>
                                                                <MenuItem value={2}>2</MenuItem>
                                                                <MenuItem value={3}>3</MenuItem>
                                                                <MenuItem value={4}>4</MenuItem>
                                                                <MenuItem value={5}>5</MenuItem>
                                                                <MenuItem value={6}>6</MenuItem>
                                                            </Select>
                                                        </FormControl> */}
                                                        <TextField
                                                            type="number"
                                                            size="small"
                                                            fullWidth
                                                            name={i}
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            onKeyPress={preventMinus}
                                                            value={items.sunCount === 0 ? "" : items.sunCount}
                                                            inputProps={{
                                                                min: 0,
                                                                max: nightCount.get().sunCount,
                                                                step: "1"
                                                            }}
                                                            sx={{
                                                                width: {
                                                                    xs: '100%',
                                                                    md: '80%',
                                                                },
                                                            }}
                                                            onChange={(e) => { sunNightCountChange(e); handleDisableBtn() }}
                                                        />
                                                    </Grid>
                                                    <Grid align="center" xs={2}>${!isNaN(Number(items.sunNightTotalCount) * Number(items.sunCount)) ? Number(items.sunNightTotalCount) * Number(items.sunCount) : 0}</Grid>
                                                </Grid>
                                            </>
                                        )
                                    })}
                                </TableCell>
                            </TableRow>
                        </TableBody>

                    </Table>
                </TableContainer>
                {/* <Box sx={{ pl: 2, pt: 2 }}>
                    <Title title="Contact for Purchase Ticket" />
                </Box> */}
                {/* <Box sx={{ mt: 2 }} display={'flex'} flexDirection={'row'}> */}
                {/* <TextField
                        fullWidth
                        required
                        sx={{
                            width: {
                                xs: '100%',
                                md: '33%',
                            },
                            paddingRight: 2
                        }}
                        size="small"
                        id="outlined-required"
                        inputProps={{ maxLength: 50 }}
                        value={state.get().name}
                        onChange={(e) =>
                        {
                            onPurchaseNameChange(e.target.value)
                        }}
                        label="Name"
                        error={
                            purchaseNameError.length > 0
                                ? true
                                : false
                        }
                        helperText={
                            purchaseNameError.length > 0
                                ? purchaseNameError
                                : ''
                        }
                    />
                    <TextField
                        fullWidth
                        required
                        sx={{
                            width: {
                                xs: '100%',
                                md: '33%',
                            },
                            paddingRight: 2
                        }}
                        size="small"
                        id="outlined-required"
                        inputProps={{ maxLength: 50 }}
                        value={state.get().email}
                        onChange={(e) =>
                        {
                            onPurchaseEmailChange(e.target.value)
                        }}
                        label="Email"
                        error={
                            purchaseEmailError.length > 0
                                ? true
                                : false
                        }
                        helperText={
                            purchaseEmailError.length > 0
                                ? purchaseEmailError
                                : ''
                        }
                    /> */}
                {/* <InputMask
                        mask="(999) 999-9999"
                        value={state.get().phone}
                        defaultValue={state.get().phone}
                        onChange={(e) =>
                        {
                            const ph = e.target.value;
                            state.phone.set(ph);
                            onPurchasePhoneChange(ph);
                        }}
                        onBlur={(e) => onPurchasePhoneChange(e.target.value)}
                    >
                        {() => (
                            <TextField
                                size="small"
                                fullWidth
                                required
                                label="Phone"
                                variant="outlined"
                                value={state.get().phone}
                                sx={{
                                    width: {
                                        xs: '100%',
                                        md: '33%',
                                    },
                                    paddingRight: 2
                                }}
                                error={
                                    purchasePhoneError.length > 0
                                        ? true
                                        : false
                                }
                                helperText={
                                    purchasePhoneError.length > 0
                                        ? purchasePhoneError
                                        : ''
                                }
                            />
                        )}
                    </InputMask> */}
                {/* <Box sx={{ width: '33%' }}>
                        <PhoneNumber
                            name={'PurchaseContact'}
                            placeholder="Phone"
                            value={state.phone.get()}
                            onChange={(ph) =>
                            {
                                state.phone.set(ph);
                                onPurchasePhoneChange(ph);
                            }}
                            required={true}
                            helperText={purchasePhoneError}
                            error={purchasePhoneError.length > 0 ? true : false}
                        />
                    </Box> */}
                {/* </Box> */}
                <Box component="div"
                    sx={{
                        display: 'flex',
                        alignItems: "right",
                        justifyContent: 'right',
                        mt: 1
                    }}>
                    {selectedCard ?
                        <Box component="div" sx={{ pl: 1, pr: 1, pt: 0.5, pb: 0.5 }}>
                            {/* <img src={`${logoURL}${'visa'}.svg`} width='24' height={16} style={{border: '1px solid #ccc', borderRadius: 4, marginRight: '8px'}} />{`****-${'4000'} - ${'Amit'}`} */}
                            <img src={`${logoURL}${selectedCard.brand}.svg`} width='24' height={16} style={{ border: '1px solid #ccc', borderRadius: 4, marginRight: '8px' }} />{`****-${selectedCard.summary} - ${selectedCard.cardName}`}
                        </Box>
                        : null}
                    <Button
                        variant="outlined"
                        onClick={addCreditCard}
                        sx={{ borderColor: showCardValidationMessage ? '#FF4D4D' : '', mr: '5px' }}
                    >
                        <span
                            style={{
                                color: showCardValidationMessage ? '#FF4D4D' : '',
                            }}
                        >
                            {editID ? 'Edit Card Details' : 'Add Card Details'}
                        </span>
                    </Button>
                    <Button
                        variant="contained"
                        onClick={addPurchase}
                        disabled={(eventInfo.readonlyOrHide === 1 ? true : props.modPermission === VIEW_PERMISSION ? true : disablePurBtn ? true : false)}
                    >
                        {btnName ? "Update Request" : "Add Request"}
                    </Button>
                </Box>
                {showCreditCard ?
                    <AddCreditCard
                        showCreditCard={showCreditCard}
                        hideCreditCard={setShowCreditCard}
                        storeCardInfo={storeCardInfo}
                        userID={props.participant ? props.participant.userID : userID}
                        eventID={eventID}
                        connection={props.agentInfo ? props.agentInfo.userID : (props.participant ? props.participant.userID : userID)}
                        prevCreditCards={prevCreditCards}
                        setSnackBarProps={props.setSnackBarProps}
                        existingCard={existingCard}
                        setShowCardValidationMessage={setShowCardValidationMessage}
                    />
                    : null}
                <Grid container spacing={1} sx={{ mt: 1 }}>
                    <Grid item sm={12}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Requests</TableCell>
                                        <TableCell align="center">Ticket requests per night (F/Sa/Su)</TableCell>
                                        <TableCell align="left">Card Info</TableCell>
                                        <TableCell align="center">Estimated Price</TableCell>
                                        <TableCell align="center">Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                {props.purchaseLoading ? <TableBody >
                                    <TableRow sx={{ height: "100px", textAlign: 'center' }}>
                                        <TableCell colSpan={4} align="center"><CircularProgress /></TableCell>
                                    </TableRow>
                                </TableBody> :
                                    <TableBody>
                                        {props.purchaseData && props.purchaseData.length > 0 ? Object.values(props.purchaseData).map((row, i) => {
                                            let FridayCount = 0;
                                            let SatCount = 0;
                                            let SunCount = 0;
                                            let tCnt = 0
                                            row.ticketAllStarDetails.map((val) => {
                                                if (val.ticketMainTypeID !== 1) {
                                                    if (val.ticketNightID === 1) {
                                                        FridayCount += val.ticketCount
                                                    } else if (val.ticketNightID === 2) {
                                                        SatCount += val.ticketCount
                                                    } else if (val.ticketNightID === 3) {
                                                        SunCount += val.ticketCount
                                                    }
                                                    tCnt += (val.price * val.ticketCount)
                                                }
                                            })
                                            if (row.ticketAllStarDetails.length > 0) {
                                                return (
                                                    <TableRow
                                                        key={i}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell align="center" component="th" scope="row">
                                                            {`Request ` + (i + 1)}
                                                        </TableCell>
                                                        <TableCell align="center">{FridayCount + '/' + SatCount + '/' + SunCount}</TableCell>
                                                        <TableCell align="left">
                                                            <Box component='span'>
                                                                <img src={`${logoURL}${row.brand}.svg`} width='24' height={16} style={{ border: '1px solid #ccc', borderRadius: 4, marginRight: '8px' }} />{`****-${row.summary} - ${row.cardName}`}
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Box component='span'>
                                                                ${tCnt}
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <EditIcon
                                                                title="Edit"
                                                                onClick={() => editPurchase(row)}
                                                                color="primary"
                                                                sx={{ mr: 1, cursor: 'pointer' }}
                                                            />
                                                            <DeleteIcon
                                                                title="Delete"
                                                                color="primary"
                                                                sx={{ ml: 1, cursor: 'pointer' }}
                                                                onClick={() => deleteAllStarDetail(row)}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }

                                        }
                                        ) : null}
                                    </TableBody>}
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Box>
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </>
    );
};

export default Purchase;